import { Pipe, PipeTransform } from '@angular/core';

import { Shop } from "../../models/shop.model";

@Pipe({
  name: 'shopFilter',
  pure: false
})
export class ShopFilterPipe implements PipeTransform {
    transform(items: Shop[], filter: string): Shop[] {
      if (!items || !filter) {
        return items;
      }

      return items.filter(item => item.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.zipcode.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.city.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }

}



// WEBPACK FOOTER //
// ./src/pipes/shop-filter/shop-filter.ts